import { useEffect, useMemo } from "preact/hooks";
import { useSheets } from "../data/sheets";
import { useEngineStore } from "../stores/engineStore";
import { useCurrentProject } from "../stores/projectStore";
import { useViewerStore } from "../stores/viewerStore";

export const BCA_JURISDICTION_ID = "sg-bca";

export function useBcaGeometrySheetMode(): {
  bcaMode: boolean;
  visibleSheets: ReturnType<typeof useSheets>;
} {
  const sheets = useSheets();
  const enabledJurisdictions = useEngineStore(s => s.enabledJurisdictions);
  const bcaMode = !!enabledJurisdictions[BCA_JURISDICTION_ID];
  const visibleSheets = useMemo(
    () => (bcaMode ? sheets.filter(s => s.kind === "3d") : sheets),
    [sheets, bcaMode]
  );
  return { bcaMode, visibleSheets };
}

/** Open 3D when BCA is on. Do not force a sheet when leaving BCA — LA/NYC still use the same 3D view. */
export function useBcaSheetAutoSwitch(): void {
  const project = useCurrentProject();
  const enabledJurisdictions = useEngineStore(s => s.enabledJurisdictions);
  const currentSheetId = useViewerStore(s => s.currentSheetId);
  const setCurrentSheet = useViewerStore(s => s.setCurrentSheet);

  useEffect(() => {
    const bcaOn = !!enabledJurisdictions[BCA_JURISDICTION_ID];
    const sheet3d = project.sheets.find(s => s.kind === "3d");

    if (bcaOn && sheet3d && currentSheetId !== sheet3d.id) {
      setCurrentSheet(sheet3d.id);
    }
  }, [enabledJurisdictions, project, currentSheetId, setCurrentSheet]);
}
